<script>
import configurationService from "@shared/services/configuration.service";
export default {
  components: {

  },
  
  data() {
    return {
      hotline: null,
    };
  },

  created(){
   this.getData();
    
  },
  
  methods: {
  
      async getData(){
        await configurationService.getPublicConfig().then((setting) => {
        this.hotline =
          setting.data.content.company.children.general.children.phone.value;
      });
      },
    
    }
};
</script>

<template>
  <div class="auth-page-wrapper">
    <div class="auth-page-content bg-white">
      <BRow class="align-items-center justify-content-center">
        
        <BCol md="5" lg="4" xl="4" class="p-0">
          <BCard no-body class="p-1 p-md-4 bg-login border-0 shadow-none">
            <div class="py-2 py-md-4">
              <inline-svg
                  src="assets/icon/remember-phone.svg"   
                  width="100%"
                  
                  fill="black"
                  
              ></inline-svg>
              </div>
              <div class="text-center">
                  <h2 class="fw-bold">{{$t("login.forgot_email")}}</h2>
                  <p class="fs-5">Liên hệ với admin qua số <a :href="'tel:'+hotline" class="fw-bold">{{hotline}}</a> để được cấp lại email đăng nhập</p>
              </div>
              <div class="my-2 my-md-3">
                <router-link :to="{'name':'app.login'}"
                  
                  class="w-100 btn btn-primary py-3 ">
                  {{ $t('login.back_to_login') }}</router-link>
              </div>

          
            
          </BCard>
        </BCol>
      </BRow>
  </div>
  </div>
</template> 